enum BulkManualPricingFailureReasonCode {
	NO_LIVE_PRICE = 'NO_LIVE_PRICE',
	PROVIDER_PRICE_DRIFT = 'PROVIDER_PRICE_DRIFT',
	VARIANCE_EXCEEDED = 'VARIANCE_EXCEEDED',
}

export default BulkManualPricingFailureReasonCode;
